/**
 * Product Options Module
 * Handles product option selection and variant switching
 */
export class ProductOptions {
    constructor(container) {
        this.options = new Map();
        this.variants = [];
        this.container = container;
        this.priceEl = document.querySelector('[data-product-price]');
        this.skuEl = document.querySelector('[data-product-sku]');
        this.stockEl = document.querySelector('[data-product-stock]');
        this.addToCartBtn = document.querySelector('[data-add-to-cart-btn]');
        this.loadVariants();
        this.init();
    }
    loadVariants() {
        const variantsData = this.container.getAttribute('data-variants');
        if (variantsData) {
            try {
                this.variants = JSON.parse(variantsData);
            }
            catch (e) {
                console.error('Failed to parse variants data');
            }
        }
    }
    init() {
        // Dropdown options
        this.container.querySelectorAll('select[data-option-id]').forEach((select) => {
            select.addEventListener('change', (e) => {
                const target = e.target;
                const optionId = parseInt(target.getAttribute('data-option-id') || '0');
                const valueId = parseInt(target.value);
                this.selectOption(optionId, valueId);
            });
        });
        // Radio/swatch options
        this.container.querySelectorAll('input[data-option-id]').forEach((input) => {
            input.addEventListener('change', (e) => {
                const target = e.target;
                const optionId = parseInt(target.getAttribute('data-option-id') || '0');
                const valueId = parseInt(target.value);
                this.selectOption(optionId, valueId);
            });
        });
        // Initialize with default selections
        this.container.querySelectorAll('select[data-option-id]').forEach((select) => {
            const el = select;
            const optionId = parseInt(el.getAttribute('data-option-id') || '0');
            const valueId = parseInt(el.value);
            if (optionId && valueId) {
                this.options.set(optionId, valueId);
            }
        });
        this.container.querySelectorAll('input[data-option-id]:checked').forEach((input) => {
            const el = input;
            const optionId = parseInt(el.getAttribute('data-option-id') || '0');
            const valueId = parseInt(el.value);
            if (optionId && valueId) {
                this.options.set(optionId, valueId);
            }
        });
        this.updateVariant();
    }
    selectOption(optionId, valueId) {
        this.options.set(optionId, valueId);
        this.updateVariant();
    }
    updateVariant() {
        const variant = this.findMatchingVariant();
        if (variant) {
            // Update hidden variant ID input
            const variantInput = this.container.querySelector('input[name="variant_id"]');
            if (variantInput) {
                variantInput.value = variant.id.toString();
            }
            // Update price
            if (this.priceEl && variant.price) {
                const salePrice = variant.salePrice || variant.sale_price;
                if (salePrice) {
                    this.priceEl.innerHTML = `
            <span class="price-was"><s>$${variant.price.toFixed(2)}</s></span>
            <span class="price-now">$${salePrice.toFixed(2)}</span>
          `;
                }
                else {
                    this.priceEl.innerHTML = `$${variant.price.toFixed(2)}`;
                }
            }
            // Update SKU
            if (this.skuEl && variant.sku) {
                this.skuEl.textContent = variant.sku;
            }
            // Update stock status
            const inStock = variant.inventoryLevel > 0 || variant.inventory_level > 0;
            const isPurchasingDisabled = variant.isPurchasingDisabled || variant.purchasing_disabled;
            if (this.stockEl) {
                if (isPurchasingDisabled) {
                    this.stockEl.textContent = 'Unavailable';
                    this.stockEl.className = 'stock-status stock-status--unavailable';
                }
                else if (inStock) {
                    this.stockEl.textContent = 'In Stock';
                    this.stockEl.className = 'stock-status stock-status--in-stock';
                }
                else {
                    this.stockEl.textContent = 'Out of Stock';
                    this.stockEl.className = 'stock-status stock-status--out-of-stock';
                }
            }
            // Update add to cart button
            if (this.addToCartBtn) {
                this.addToCartBtn.disabled = isPurchasingDisabled || !inStock;
            }
            // Update image if variant has one
            if (variant.imageUrl || variant.image_url) {
                const imageUrl = variant.imageUrl || variant.image_url;
                const mainImage = document.querySelector('[data-main-image]');
                if (mainImage) {
                    mainImage.src = imageUrl;
                }
            }
            // Dispatch event
            document.dispatchEvent(new CustomEvent('product:variant-changed', {
                detail: { variant, options: Object.fromEntries(this.options) }
            }));
        }
    }
    findMatchingVariant() {
        if (this.variants.length === 0)
            return null;
        return this.variants.find((variant) => {
            const optionValues = variant.optionValues || variant.option_values || [];
            return optionValues.every((ov) => {
                const selectedValue = this.options.get(ov.optionId || ov.option_id);
                return selectedValue === (ov.valueId || ov.id);
            });
        });
    }
}
export default ProductOptions;
